import { Component, Input, Output, EventEmitter, OnInit } from 'ng-metadata/core';
import './ingress.component.scss';

/**
 * @ngdoc directive
 * @name mwContentDocumentIngress
 * @module mw.components.contentDocuments
 *
 * @param {string} [text] - The document ingress text.  This can be an HTML string.
 *
 * @description
 * `<mw-content-document-ingress>` provides a means for displaying the ingress of a content document.
 *
 * @usage
 * <hljs hljs-language="html">
 *   <!-- Using transclusion -->
 *   <mw-content-document-ingress text="$ctrl.ingress"></mw-content-document-ingress>
 *
 * </hljs>
 *
 */
@Component({
    selector: 'mw-content-document-ingress',
    template: `
        <div class="mw-content-document-ingress"
            ng-bind-html="::($ctrl.text | mwSanitizeInvalidHtml | mwLinkyHtml)">
        </div>
    `,
    legacy: {
        transclude: true
    }
})
export class IngressComponent implements OnInit {
    @Input('<') text: string[];

    constructor() {
        'ngInject';
    }

    ngOnInit() {
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-document/ingress/ingress.component.ts